<template>
  <!--  -->
  <div class="text-bg">
    <el-dialog
      id="notification"
      :title="$t('tips.document_requirement')"
      :visible.sync="dialogVisible"
      width="836px"
      :close-on-click-modal="false"
      class="dialog-card"
    >
      <div class="header-line" />
      <div class="content">
        <div class="text-bg-1">
          <span class="text-lift">{{ $t('tips.contract_basic_review_title') }}</span>
          <span class="text-right">
            <div class="mb-16">{{ $t('tips.contract_basic_review_1') }}</div>
            <div class="mb-16">{{ $t('tips.contract_basic_review_2') }}</div>
            <div class="mb-16">{{ $t('tips.contract_basic_review_3') }}</div>
            <div class="mb-16">{{ $t('tips.contract_basic_review_4') }}</div>
            <div>{{ $t('tips.contract_basic_review_5') }}</div>
          </span>
        </div>
        <div class="header-line" />
        <div class="text-bg-2">
          <span class="text-lift">{{ $t('tips.contract_entity_title') }}</span>
          <span class="text-right">
            <div class="mb-16">{{ $t('tips.contract_entity_1') }}</div>
            <div class="mb-16">{{ $t('tips.contract_entity_2') }}</div>
            <div>{{ $t('tips.contract_entity_3') }}</div>
          </span>
        </div>
        <div class="header-line" />
        <div class="text-bg-1">
          <span class="text-lift">{{ $t('tips.contractual_rights_and_obligations_title') }}</span>
          <span class="text-right">
            <div>{{ $t('tips.contractual_rights_and_obligations_1') }}</div>
          </span>
        </div>
        <div class="header-line" />
        <div class="text-bg-2">
          <span class="text-lift">{{ $t('tips.contract_object_quantity_quality_title') }}</span>
          <span class="text-right">
            <div class="mb-16">{{ $t('tips.contract_object_quantity_quality_1') }}</div>
            <div>{{ $t('tips.contract_object_quantity_quality_2') }}</div>
          </span>
        </div>
        <div class="header-line" />
        <div class="text-bg-1">
          <span class="text-lift">{{ $t('tips.contract_price_or_compensation_title') }}</span>
          <span class="text-right">
            <div class="mb-16">{{ $t('tips.contract_price_or_compensation_1') }}</div>
            <div class="mb-16">{{ $t('tips.contract_price_or_compensation_2') }}</div>
            <div>{{ $t('tips.contract_price_or_compensation_3') }}</div>
          </span>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button type="info" class="btn-submit" @click="dialogVisible = false">Close</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ContractDescriptionModal',
  data() {
    return {
      dialogVisible: false
    }
  },
  created() {
  },
  methods: {
    showModal() {
      this.dialogVisible = true
    }
  }

}

</script>
<style scoped lang="scss">
#notification {
  ::v-deep.el-dialog__header {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  ::v-deep.el-dialog__body {
    padding: 0;
  }
  ::v-deep.el-dialog__title{
    font-size: 22px;
    font-weight: bold;
    color: #3855F1;
  }
  ::v-deep.el-dialog{
    border-radius: 14px;
  }
  .text-bg-1{
    display: flex;
    padding: 16px 24px;
    background-color: #98A1B426;
  }
  .text-bg-2{
    display: flex;
    padding: 16px 24px;
  }
  .text-lift{
    width: 320px;
    margin-right: 18px;
    color: #1D3A71;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .text-right{
    word-break: normal;
    width: 450px;
    color: #1C1C1C;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
  .header-line{
    margin: 0;
    border-bottom: 2px solid #D3D7DF;
  }

  .section-title{
    margin-top: 32px;
    margin-bottom: 16px;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #000000;
  }
  .dialog-card{
    height: 750px;
    border-radius: 14px;
    background-color: #D3D7DF;
  }
  .content{
    height: 600px;
    overflow: auto;
  }
  .btn-submit{
    padding: 12px;
    width: 500px;
    // height: 40px;
    font-weight: 700;
    font-size: 16px;
    margin-top: 29px;
    margin-bottom: 40px;
  }
  .dialog-footer{
    margin-top: 13px;
    text-align: center;
  }
  .mb-16{
    margin-bottom: 16px;
  }
}
</style>
<style>
#notification {

}
</style>
